import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KuiBadgeComponent } from './badge.component';

@NgModule({
  imports: [CommonModule],
  exports: [KuiBadgeComponent],
  declarations: [KuiBadgeComponent],
})
export class KuiBadgeModule {}
